<template>
    <div class="px-10 my-4 py-6 bg-white rounded-lg shadow-md">
        <div class="flex justify-between items-center">
            <span class="font-light text-gray-600">April 27th, 2020</span>
            <a class="px-2 py-1 text-gray-100 font-bold rounded bg-pink-500" href="#">LATEST</a>
        </div>
        <div class="mt-2">
            <a class="text-2xl text-gray-700 font-bold hover:text-gray-600" href="#">IF YOU SEE THIS IT WORKED. CHECK THE AVATAR IN THE UPPER RIGHT.</a>
            <p class="mt-2 text-gray-600"></p>
        </div>
        <div class="flex justify-between items-center mt-4">
            <a class="text-blue-600 hover:underline" href="#">Read more</a>
        </div>
    </div>
</template>

<script>
  import store from '@/store/'

  export default {
    name: 'RecentNews',
    computed: {
      news() {
        return store.state.recentNews
      }
    },
    methods: {
      getNews() {
        store.dispatch('fetchNews')
      }
    },
    mounted () {
      this.getNews();
    },
  }
</script>
